<template>
	<div class="bottom">
		<div class="bg-white router-all">
			<div class="cont">
				<div class="flex ">
					<div class="flex-sub text-df all-item solid-right pointer" @click="golink(item)" v-for="(item,index) in bottomrouter" :key="index">{{item.name}}</div>
				</div>
				<div class="flex justify-between padding-lr other">
					<div class="flex">
						<div class="external">
							<div class="flex justify-between align-center solid-bottom margin-bottom-sm ">
								<p class="text-sm text-333 text-bold margin-bottom-xs">友情链接</p>
								<p class="text-sm text-666 margin-bottom-xs pointer">更多</p>
							</div>
							<el-row :gutter="0">
							  <el-col v-for="(item,index) in externallink" :key="index" :span="5"><div @click="gowlink(item.url)" class="margin-bottom-xs text-xs text-999 pointer">{{item.title}}</div></el-col>
							</el-row>
						</div>
						<div class="contact">
							<div class="flex justify-between align-center solid-bottom">
								<p class="text-sm text-333 text-bold margin-bottom-xs">联系方式</p>
							</div>
							<div class="flex flex-direction justify-between align-start">
								<p class="text-xs text-999 margin-top-xs">热线电话：{{kf_phone}}</p>
								<p class="text-xs text-999 margin-top-xs">工作时间：{{store_work_time}}</p>
								<p class="text-xs text-999 margin-top-xs">平台网址：{{site_url}}</p>
							</div>
						</div>
					</div>
					<div class="flex align-center">
						<p class="title">扫码进入</p>
						<img class="ercode" :src="footer_ewm" >
					</div>
				</div>
			</div>
		</div>
		<div class="record text-xs text-666"><span class="pointer">{{record_no}}</span></div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data () {
			return {
				work_ewm:'',
				kf_phone:'',//客服电话
				store_work_time:'',//工作时间
				site_url:'',//官网
				footer_ewm:'',//底部二维码
				record_no:'',//备案信息
				bottomrouter:[//底部连接
					{
						name:'蓝友介绍',
						path:'about',
					},{
						name:'实名认证',
						path:'center',
						query:{
							type:'idcard'
						}
					},{
						name:'企业认证',
						path:'center',
						query:{
							type:'enterprise'
						}
					},{
						name:'广告合作',
						path:'advert',
					},{
						name:'问题与反馈',
						path:'center',
						query:{
							type:'feedback'
						}
					},{
						name:'申请发票',
						path:'center',
						query:{
							type:'apply'
						}
					},{
						name:'发票记录',
						path:'center',
						query:{
							type:'recordt'
						}
					},{
						name:'政策解读',
						path:'policy'
					},{
						name:'法律声明',
						path:'law'
					},
				],
				externallink:[//外部连接
					{
						name:'华为云 '
					},{
						name:'腾讯云'
					},{
						name:'百度云'
					},{
						name:'京东数科'
					},{
						name:'互联网联盟'
					},{
						name:'达索3DS'
					},{
						name:' 筑龙网'
					},{
						name:'中房网'
					},{
						name:'树根互联'
					},{
						name:'树根互联'
					},{
						name:'树根互联'
					},{
						name:'树根互联'
					},
				]
				
			}
		},
		created(){
			// this.getwordsewm()
			this.getFooter()
			this.getsystemFooter()
		},
		methods:{
			golink(item){
				let query={}
				if(item.query){
					query = item.query
				}
				if(item.path == 'center'){
					if(localStorage.getItem('user_token')){
						this.$router.push({
							name:item.path,
							query
						})
					}else{
						Bus.$emit("showlogon")
					}
				}else{
					this.$router.push({
						name:item.path,
						query
					})
					this.$forceUpdate()
				}
			},
			gowlink(url){
				window.location.href = url
			},
			
			//获取友情链接
			getFooter(){
				this.ajax('get', '/api/pc/links/getList', {}, res => {
					if(res.status == 200){
						this.externallink = res.data.data
					}
				})
			},
			//获取友情链接
			getsystemFooter(){
				this.ajax('get', '/api/pc/system/getFooter', {}, res => {
					if(res.status == 200){
						this.kf_phone = res.data.kf_phone
						this.store_work_time = res.data.store_work_time
						this.site_url = res.data.site_url
						this.footer_ewm = res.data.footer_ewm
						this.record_no = res.data.record_no
						
					}
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.el-col-5{
		width: 20% !important;
	}
	.bottom{
		border-top: 3px solid #09827B;
		background: #F6F6F8;
		// position: absolute;
		// bottom: 0;
		// left: 0;
		// right: 0;
		height: 328px;
		.router-all{
			padding: 31px 0;
			.cont{
				width: 1230px;
				margin: 0 auto;
				.all-item{
					border-right: 1px solid #333;
				}
				.all-item:last-child{
					border-right: 0;
				}
				.other{
					margin-top: 40px;
				}
				.external{
					width: 566px;
					margin-right: 99px;
				}
				.contact{
					width: 274px;
				}
				.title{
					width: 20px;
				}
				.ercode{
					width: 96px;
					height: 96px;
				}
			}
		}
		.record{
			background: #F6F6F8;
			height: 52px;
			line-height: 52px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/public/bottom.vue